<template>
  <div class="maxMaxth evebt">
    <div class="_QHPzkqbnIhdrHoFHZU1">
      <div class="FNothGJnr_XkMpVC9saQ">
        <span class="CBnmKFFy5fD3SQnxH3g9">{{ $t('_VIP._NívelAtual') }}</span>
        <div
          class="JlCRc6ttKGcNUyDwFygw reward-mixins__levelImage l2ogUtOtFSdH0ER0ochY"
          style="
            flex: 0 0 1rem;
            width: 1rem;
            height: 1rem;
            font-size: 0.363636rem;
          "
        >
          <img
            v-lazy="formDelList.backgroud"
            style="width: 1rem; height: 1rem"
          />
          <img
            v-lazy="formDelList.icon"
            class="goDRiiBsuEuXD3W1NphN"
            style="width: 1rem; height: 1rem"
          />
          <span :data-text="formDelList.level">{{ formDelList.level }}</span>
        </div>
        <div
          class="wVdHCegt0XdSulmA2Baj Fp0NS_G0kOgjuJJrHtPc reward-mixins__progressContent"
        >
          <div class="EP7cYZQjy3x8bePovMwY reward-mixins__progressNeed">
            <span
              >{{ $t('_VIP._Restantes')
              }}<i>{{ formDelList.next_level_name }}</i></span
            >
            <span
              >{{ $t('_VIP._Apostemais') }}
              <strong>{{ formDelList.upneed_bet }}</strong></span
            >
          </div>

          <div class="yTrC9_SkCM0s2UT24Rop">
            <van-button
              type="primary"
              size="small"
              :disabled="avaliableReward?.length == 0"
              :style="{
                backgroundColor:
                  avaliableReward?.length > 0
                    ? 'var(--theme-primary-color)'
                    : 'var(--theme-disabled-bg-color)',
                color:
                  avaliableReward?.length > 0
                    ? 'var(--theme-primary-font-color)'
                    : 'var(--theme-disabled-font-color)'
              }"
              @click="receiveReward"
              >{{ $t('_VIP._ResgatarTudo') }}</van-button
            >
            <van-button
              @click="openUrl('records')"
              type="primary"
              size="small"
              >{{ $t('_VIP._Histórico') }}</van-button
            >
          </div>
        </div>
      </div>

      <div class="ejJ7KgJPi3aEwhNsCfew theme-box-shadow">
        <div class="oWOki6dTquZVWAx0lScK">
          {{ $t('_VIP._ListadeníveisVIP') }}
        </div>
        <div class="OxGvwfHXXQVNNNoH8gV2">
          <van-tabs
            v-model="activeName"
            @click="routerFun"
            :lineWidth="activeLength * 6 + 'px'"
            animated
            line-height="2px"
            background="transparent"
            :ellipsis="false"
            title-active-color="var(--theme-primary-color)"
            title-inactive-color="var(--theme-text-color-darken)"
            color="var(--theme-primary-color)"
          >
            <van-tab
              title-style="font-size: 0.22rem;"
              v-for="(item, index) in tabList"
              :title="$t(item.name)"
              :name="index"
              :key="index"
            >
              <component
                :Nvel_ss.sync="Nvel_ss"
                :is="item.content"
                :formDelList="formDelList"
                :item="item"
              ></component>
            </van-tab>
          </van-tabs>
        </div>
      </div>
      <div
        class="ejJ7KgJPi3aEwhNsCfew theme-box-shadow"
        style="padding-bottom: 1.2rem"
      >
        <div class="oWOki6dTquZVWAx0lScK">
          {{ $t('_VIP._InstruçõessobreregrasVIP') }}
        </div>
        <div class="FFVTf32mKWROQCq1OHEb">
          1. {{ $t('_VIP._des_1') }}<br />
          2. {{ $t('_VIP._des_2') }}<br />
          3. {{ $t('_VIP._des_3') }}<br />
          4. {{ $t('_VIP._des_4') }}<br />
          5. {{ $t('_VIP._des_5') }}<br />
          6. {{ $t('_VIP._des_6') }}<br />
          7. {{ $t('_VIP._des_7') }}<br />
          8. {{ $t('_VIP._des_8') }}<br />
        </div>
      </div>
    </div>
    <!-- Nvel_ss -->
    <ant-modal
      :isModel.sync="Nvel_ss"
      :content="$t('_VIP._LembreteConter')"
      :title="$t('_VIP._Lembrete')"
    ></ant-modal>
  </div>
</template>

<script>
// vipDetail
import { vipDetail, receiveVipBonus } from '@/apis/modules/game.js';
import Aumento from './Aumento.vue';
import nusSemanal from './BônusSemanal.vue';
import nusMensal from './BônusMensal.vue';
import PriviVIP from './PriviVIP.vue';
import { Toast } from 'vant';

export default {
  name: 'vip',
  components: {},
  data() {
    return {
      activeName: 0,
      activeLength: 25,
      Nvel_ss: false,
      tabList: [
        {
          name: 'popup._BônusDeAumentoDeNível',
          route: 'event',
          content: Aumento
        },
        {
          name: 'popup._BônusSemanal',
          route: 'vip',
          content: nusSemanal
        },
        {
          name: 'popup._BônusMensal',
          route: 'canReceive',
          content: nusMensal
        },
        {
          name: 'popup._PrivilégioVIP',
          route: 'yuebao',
          content: PriviVIP
        }
      ],
      formDelList: {},
      avaliableReward: []
    };
  },
  created() {
    this.$store.commit('sLoading', true);
    this.vipDetail();
  },
  methods: {
    vipDetail() {
      this.avaliableReward = [];
      vipDetail({}).then(({ data, code }) => {
        this.formDelList = data;
        let obj = this.formDelList?.vip_bonus || [];
        Object.keys(obj).forEach(key => {
          if (obj[key].switch == 1) {
            this.avaliableReward.push(obj[key].type);
          }
        });
        this.$store.commit('sLoading', false);
      });
    },
    tabFun(e) {
      this.$store.commit('active', e);
    },
    routerFun(e, l) {
      this.activeLength = l.length;
    },
    stickyScroLL(e) {},
    // 领取奖励
    receiveReward() {
      // 没有可领取的奖励
      if (this.avaliableReward.length === 0) {
        Toast.fail({
          message: this.myLineBreaks('No bonus available'),
          duration: 2000
        });
        return;
      }
      let params = { type: this.avaliableReward.join(',') };
      receiveVipBonus(params).then(({ data, code, msg }) => {
        if (code == 0) {
          Toast.success({
            message: this.myLineBreaks(msg),
            duration: 2000
          });
          this.vipDetail();
        } else {
          Toast.loading({
            message: this.myLineBreaks(msg),
            duration: 2000
          });
        }
      });
    }
  }
};
</script>
<style>
.ejJ7KgJPi3aEwhNsCfew .van-tabs__wrap--scrollable {
  border-bottom: 0.01rem solid var(--theme-color-line);
  margin-bottom: 0.2rem;
}
</style>
<style scoped>
._QHPzkqbnIhdrHoFHZU1 {
  padding: 0 0.2rem;
  margin-top: 0.2rem;
}
.yTrC9_SkCM0s2UT24Rop {
  -ms-flex-align: end;
  align-items: flex-end;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
}
.FNothGJnr_XkMpVC9saQ {
  -ms-flex-align: center;
  -ms-flex-pack: justify;
  align-items: center;
  background-color: var(--theme-main-bg-color);
  border-radius: 0.12rem;
  -webkit-box-shadow: 0 0.03rem 0.09rem 0 rgba(0, 0, 0, 0.06);
  box-shadow: 0 0.03rem 0.09rem 0 rgba(0, 0, 0, 0.06);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
  padding: 0.45rem 0.2rem 0.25rem;
  padding: 0.2rem;
  position: relative;
}
.JlCRc6ttKGcNUyDwFygw,
.NPzDoGC69c0JdVxoaQso,
.l2ogUtOtFSdH0ER0ochY {
  -ms-flex-align: center;
  -ms-flex-pack: center;
  align-items: center;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: contain;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  margin: auto;
  position: relative;
  text-align: center;
}
.JlCRc6ttKGcNUyDwFygw img,
.NPzDoGC69c0JdVxoaQso img,
.l2ogUtOtFSdH0ER0ochY img {
  position: absolute;
}
.JlCRc6ttKGcNUyDwFygw span:before,
.NPzDoGC69c0JdVxoaQso span:before,
.l2ogUtOtFSdH0ER0ochY span:before {
  -webkit-background-clip: text;
  background-clip: text;
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#f7ea94),
    color-stop(51%, #e5b952),
    to(#ce9510)
  );
  background-image: linear-gradient(180deg, #f7ea94 0, #e5b952 51%, #ce9510);
  background-size: cover;
  content: attr(data-text);
  height: 100%;
  left: 0;
  position: absolute;
  text-shadow: none;
  top: 0;
  width: 100%;
  z-index: 0;
}

.JlCRc6ttKGcNUyDwFygw span,
.NPzDoGC69c0JdVxoaQso span,
.l2ogUtOtFSdH0ER0ochY span {
  color: transparent;
  display: inline-block;
  font-style: normal;
  font-weight: 700;
  position: relative;
  text-shadow: 0 0.01rem 0 rgba(0, 0, 0, 0.4);
}
.FNothGJnr_XkMpVC9saQ .CBnmKFFy5fD3SQnxH3g9 {
  -ms-flex-align: center;
  -ms-flex-pack: center;
  align-items: center;
  background-color: var(--theme-secondary-color-error);
  border-radius: 0.08rem 0.08rem 0.08rem 0;
  color: #fff;
  display: -ms-flexbox;
  display: flex;
  font-size: 0.18rem;
  height: 0.3rem;
  justify-content: center;
  left: 0;
  padding: 0 0.06rem;
  position: absolute;
  top: 0;
  z-index: 1;
}

.FNothGJnr_XkMpVC9saQ .JlCRc6ttKGcNUyDwFygw {
  margin: 0 0.2rem 0 0;
}
.FNothGJnr_XkMpVC9saQ .JlCRc6ttKGcNUyDwFygw {
  margin-top: 0.2rem;
}
.yTrC9_SkCM0s2UT24Rop button:first-child {
  margin-bottom: 0.2rem;
  /* background-color: var(--theme-disabled-bg-color);
  border-color: var(--theme-disabled-bg-color);
  color: var(--theme-disabled-font-color); */
  border: none;
}
.yTrC9_SkCM0s2UT24Rop button {
  border-radius: 0.1rem;
  font-size: 0.16rem;
  height: 0.4rem;
  line-height: 0.18rem;
  padding: 0 0.05rem;
  width: 1rem;
}

.yTrC9_SkCM0s2UT24Rop button {
  height: 0.5rem;
  width: 1.2rem;
}
.wVdHCegt0XdSulmA2Baj.Fp0NS_G0kOgjuJJrHtPc {
  -ms-flex-align: center;
  -ms-flex-pack: justify;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
}
.EP7cYZQjy3x8bePovMwY {
  font-size: 0.24rem;
  line-height: 0.26rem;
  margin-bottom: 0rem;
  padding-top: 0.2rem;
  color: var(--theme-text-color-lighten);
}
.EP7cYZQjy3x8bePovMwY span:first-child {
  display: block;
}
.FNothGJnr_XkMpVC9saQ .EP7cYZQjy3x8bePovMwY i {
  color: var(--theme-secondary-color-error);
  font-weight: 700;
  margin: 0 0.05rem;
}
.FNothGJnr_XkMpVC9saQ .EP7cYZQjy3x8bePovMwY strong {
  color: var(--theme-text-color-darken);
}
.XUsRryuA9IC2zOJlMtTr {
  text-transform: capitalize;
}
.ejJ7KgJPi3aEwhNsCfew {
  border-radius: 0.1rem;
  color: var(--theme-text-color-darken);
  font-size: 0.24rem;
  margin: 0.2rem 0;
  text-align: left;
  font-size: 0.3rem;
}
.ejJ7KgJPi3aEwhNsCfew .oWOki6dTquZVWAx0lScK {
  -ms-flex-align: center;
  -ms-flex-pack: justify;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
  line-height: auto;
  padding: 0.2rem 0.2rem 0;
  padding-left: 0px;
}
.ejJ7KgJPi3aEwhNsCfew .OxGvwfHXXQVNNNoH8gV2 {
  -ms-overflow-style: none;
  border-bottom: 0.01rem solid var(--theme-color-line);
  min-width: 100%;
  scrollbar-width: none;
}

.FFVTf32mKWROQCq1OHEb {
  font-size: 0.22rem;
  line-height: 1.64;
  border-top: 0.01rem solid var(--theme-color-line);
  color: var(--theme-text-color);
  margin-top: 0.2rem;
  padding: 0.2rem;
  text-transform: none;
  white-space: break-spaces;
  word-break: break-all;
}
.KkRUNU5i1X4v4833bPfs {
  -ms-flex-align: center;
  -ms-flex-pack: center;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  font-size: 0.14rem;
  justify-content: center;
}
._2lvGimPeAnoEFiUw_fTw {
  position: relative;
  width: 3.1rem;
  margin-top: 0.1rem;
}
._2lvGimPeAnoEFiUw_fTw .ant-progress-inner {
  background-color: var(--theme-text-color-placeholder);
  border-radius: 0.2rem;
}
._2lvGimPeAnoEFiUw_fTw .ant-progress-inner .ant-progress-bg {
  background-color: var(--theme-vip-progress-bg-color);
  border-radius: 0.2rem !important;
  height: 0.2rem !important;
}
._2lvGimPeAnoEFiUw_fTw > span {
  -webkit-background-clip: text !important;
  color: #fff;
  font-size: 0.16rem;
  left: 50%;
  overflow: hidden;
  position: absolute;
  text-align: center;
  text-overflow: ellipsis;
  top: 60%;
  transform: translate(-50%, -58%);
  white-space: nowrap;
  width: 94%;
}
</style>
